<template>
  <page-view title="单位查询">
    <template slot="action">
      <a-button type="primary" icon="plus" @click="AddOrEditUnit('')">添加单位</a-button>
    </template>
    <a-card class="mb-3">
      <a-form-model class="exi_form v2"
                    ref="form" :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
        <a-form-model-item>
          <a-input style="width: 500px" placeholder="请输入单位名称、统一信用代码"
                   v-model="queryForm.unitName"></a-input>
        </a-form-model-item>
        <a-button type="primary" icon="search" @click="onSearch">查询</a-button>
        <a-button class="ml-2" @click="reset">重置</a-button>
      </a-form-model>
    </a-card>
    <a-card>
      <s-table ref="table"
               :columns="columns"
               :rowKey="record => record.id"
               :data="loadData"
               :pagination="{ showTotal: (total) => `共 ${total} 条` }"
               class="border"
               size="middle">
        <template slot="action" slot-scope="text, record">
          <a @click="AddOrEditUnit(record.id)">编辑</a>
          <a-divider type="vertical"/>
          <a @click="onView(record)">查看</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="是否确认删除?" @confirm="onDelUnit(record)">
            <a class="color-ash" href="#">删除</a>
          </a-popconfirm>
        </template>
      </s-table>
    </a-card>
    <add-or-edit-unit-modal ref="unitModal" :visible="showUnitModal" @cancel="showUnitModal = false"
                            @success="OnSuccessUnitModal"></add-or-edit-unit-modal>

  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import { QueryUnitVo, DelUnit } from './api/UnitRequest'
import AddOrEditUnitModal from './AddOrEditUnitModal'
import ChoosePurchaseItem from '../purchaseitems/ChoosePurchaseItem'

export default {
  name: 'QueryUnit',
  components: {
    PageView,
    STable,
    AddOrEditUnitModal,
    ChoosePurchaseItem
  },
  filters: {},
  data () {
    return {
      showUnitModal: false,
      columns: [
        {
          title: '单位名称',
          ellipsis: true,
          dataIndex: 'unitName',
          align: 'left',
          scopedSlots: { customRender: 'unitName' }
        },
        {
          title: '统一信用代码',
          dataIndex: 'creditCode',
          align: 'center',
          scopedSlots: { customRender: 'creditCode' }
        },
        {
          title: '关联单位数量',
          align: 'center',
          dataIndex: 'unitItemNum',
          width: '150px',
          scopedSlots: { customRender: 'unitItemNum' }
        },
        {
          title: '操作',
          width: '180px',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      user: this.$ls.get('user'),
      queryForm: {
        unitName: ''
      },
      loadData: parameter => {
        const params = { ...parameter, ...this.queryForm }
        return QueryUnitVo(params)
      },
    }
  },
  created () {
  },
  methods: {

    //打开添加编辑页面
    AddOrEditUnit (id) {
      this.showUnitModal = true
      this.$refs.unitModal.onLoad(id)
    },
    //添加或编辑成功后回调
    OnSuccessUnitModal () {
      this.showUnitModal = false
      this.$refs.table.refresh()
    },

    onView (record) {
      this.$router.push({ path: '/expert/unitItemManage?unitId=' + record.id })
    },
    async onDelUnit (record) {
      let that = this
      let res = await DelUnit(record.id)
      if (res.code == 200) {
        that.$message.success('删除成功')
        that.$refs.table.refresh()
      } else {
        that.$message.error('删除失败')
      }
    },
    reset () {
      this.queryForm = {}
      this.onSearch()
    },
    onSearch () {
      this.queryParam = { ...this.queryForm }
      // 日期组件返回的是 moment 对象，需要转换为字符串时间
      this.$refs.table.refresh(true)
    },

  }
}
</script>

<style scoped>

</style>
